export { default } from './ukheshe-scanToPay';
